import { Injectable, OnDestroy } from '@angular/core';
import { ApModalResult, ApModalService } from 'webcommon/core-ui';
import { ApBaseClass, IColumnPk, IDeleted } from 'webcommon/shared';
import { FcItemModalContext, FcItemModalMode } from '../models/index';
import { ApFindControlService } from './ap-findcontrol.service';
import { FcItemConfig } from './fc-item-config';
import { DeleteModalComponent } from '../delete-modal';
import {  Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FcItemModalService extends ApBaseClass implements OnDestroy {

  dataItem: IColumnPk & IDeleted | null = null;


  public readonly viewOptionActionType = new Subject<string>();
  public viewOptionType$ = this.viewOptionActionType.asObservable();

  readonly viewOptionUpdateEmitterSubject = new Subject<string | null>();
  readonly viewOptionUpdateEvent$ = this.viewOptionUpdateEmitterSubject.asObservable();


  readonly deleteViewOptionFilterSubject = new Subject< IColumnPk & IDeleted | null>();
  readonly deletedViewOptionEvent$ = this.deleteViewOptionFilterSubject.asObservable();

  constructor(
    private apModalService: ApModalService,
    private fcItemConfig: FcItemConfig,
    private apFindControlService: ApFindControlService,
  ) {
    super();
  }

  openModal(
    fcModalItemContext: FcItemModalContext,
  ): Promise<ApModalResult<IColumnPk>> {
    const initialState = {
      fcModalItemContext
    };

    const findControlModalType = this.fcItemConfig.getItemModalTypeOrDefault(fcModalItemContext);

    const p = this.apModalService.showComponentModal(findControlModalType.component, {
      panelClass: findControlModalType.modalSize,
      disableClose: true,
      initialState,
    });

    if (fcModalItemContext.mode === FcItemModalMode.Modify) {
      this.apFindControlService.updateMfuMruList(fcModalItemContext.findControlId, [fcModalItemContext.selectedFindItemPk]).pipe(
        this.takeUntilDestroy(),
      ).subscribe();
    }

    return p;
  }

  // Open the delete modal
  openDeleteModal(filterName: string): Promise<boolean | null> {
    return this.apModalService.showComponentModal(DeleteModalComponent, {
      panelClass: 'emds-modal-small',
      disableClose: true,
      initialState: { title: filterName }
    });
  }

  public setViewOptionType(emissionType: string): void {
    this.viewOptionActionType.next(emissionType);
  }
}
